export default "__VITE_ASSET__Di00NeV3__"